import { Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
  blank: {
    minWidth: Platform.select({
      web: 120,
      default: 100,
    }),
    borderRadius: 4,
    minHeight: Platform.select({
      web: 32,
      default: 26,
    }),
    paddingHorizontal: 8,
    alignItems: 'center',
    borderWidth: 1,
    borderStyle: 'dashed',
  },
  nonEmptyBlank: {
    marginTop: 2,
    paddingHorizontal: 15,
    paddingVertical: 2,
    alignItems: 'center',
    borderWidth: 1,
    borderBottomWidth: 3,
    borderRadius: 10,
  },
  nonEmptyBlankText: {
    fontSize: 16,
    lineHeight: 22,
  },
  menuContent: {
    paddingTop: 0,
    paddingBottom: 0,
    overflow: 'hidden',
    borderWidth: 1,
  },
  finalText: {
    fontWeight: 'bold',
  },
});
